export default __webpack_public_path__ + "static/media/GuyAnimation12.faa998e7.svg";